import { Typography, styled } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
    `,
    List: styled("ul")`
        margin: 20px 0px;
        width: 550px;
        max-height: 350px;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 10px;
        }

        &::-webkit-scrollbar-thumb {
            background: #6c5ecf;
            border-radius: 10px;
            border: 3px solid transparent;
            background-clip: padding-box;
        }

        &::-webkit-scrollbar-thumb:hover {
            border: 1px solid transparent;
        }

        &::-webkit-scrollbar-track {
            background: black;
        }
    `,
    ListItem: styled("li")<{ selected?: boolean }>`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background-color: ${props =>
            props.selected ? props.theme.palette.primary.main : props.theme.palette.secondary.main};
        cursor: pointer;
        padding: 20px;
        margin: 10px 5px;
        border-radius: 8px;
        &:hover {
            background-color: ${props => props.theme.palette.primary.main};
        }
    `,
    CompanyId: styled(Typography)``,
};
